export function produtosInRequest(params = {}) {
  return {
    type: '@produto/PRODUTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findProduto(idproduto) {
  return {
    type: '@produto/FIND_PRODUTO',
    payload: { idproduto },
  };
}

export function failedRequest() {
  return {
    type: '@produto/FAILED_REQUEST',
  };
}

export function deleteProduto(idproduto, params) {
  return {
    type: '@produto/DELETE_PRODUTO',
    payload: { idproduto, params },
  };
}

export function updateProduto(produto, params) {
  return {
    type: '@produto/UPDATE_PRODUTO',
    payload: { produto, params },
  };
}

export function storeProduto(produto, params) {
  return {
    type: '@produto/STORE_PRODUTO',
    payload: { produto, params },
  };
}

export function successInRequest(
  produtos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@produto/SUCCESS_IN_REQUEST',
    payload: { produtos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(produto) {
  return {
    type: '@produto/SUCCESS_REQUEST',
    payload: { produto },
  };
}

export function successRemove(params) {
  return {
    type: '@produto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@produto/RECORD_FILTERING',
    payload: { params },
  };
}
